import React, { Fragment, Component, Suspense, lazy } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import {connect} from 'react-redux';
import ReactGA from 'react-ga4';
import { Popover } from 'react-tiny-popover';
import axios from "axios";
import Swal from "sweetalert2";
import {isIE} from 'react-device-detect';

import i18n from './i18n';
import env from "./env/src_config";
import { setLanguage, findGetParameter, parseJwt } from "./izUtils";
import { setOrgParamsPublic } from './hoc/Organization/OrganizationParamsBidder';

/* import HOC */
const Header = lazy(() => import('./hoc/Header/Header'));
const Leftside = lazy(() => import('./hoc/Leftside/Leftside'));
const Footer = lazy(() => import('./hoc/Footer/Footer'));
const CookieConsent = lazy(() => import('./hoc/CookieConstent/CookieConsent'));
const Loading = lazy(() => import('./hoc/Loading/Loading'));

/* subscriber */
const SubscriberDashboard = lazy(() => import('./Subscriber/Dashboard/Dashboard'));
const Create2 = lazy(() => import('./Subscriber/Drafts/Create2/Create2'));
const DraftList = lazy(() => import('./Subscriber/Drafts/List/List'));
const PublishedList = lazy(() => import('./Subscriber/Published/List/List'));
const ArchiveList = lazy(() => import('./Subscriber/Archive/List/List'));
const SubscriberInvitedList = lazy(() => import('./Subscriber/Invited/List/List'));
const FinishedList = lazy(() => import('./Subscriber/Finished/List/List'));
const PublishedCancel = lazy(() => import('./Subscriber/Published/Cancel/Cancel'));
const PublishedUpdate2 = lazy(() => import('./Subscriber/Published/Update/NewUpdate'));
const PublishedSingle = lazy(() => import('./Subscriber/Published/Single/Single'));
const PublishedSinglePrintAll = lazy(() => import('./Subscriber/Published/Single/SinglePrintAll'));
const SubscriberProfile = lazy(() => import('./Subscriber/Profile/Profile'));
const PublishedSingleBidder = lazy(() => import('./Subscriber/Published/Single/Parts/Bidders/Bidder/Bidder'));
const PublishedSingleDecision = lazy(() => import('./Subscriber/Published/Single/Parts/Decisions/Decision/Decision'));
const PublishedBiddersList = lazy(() => import('./Subscriber/Published/Bidders/List/List'));
const PublishedBidders = lazy(() => import('./Subscriber/Published/Bidders/Single/Single'));
const FinishedEnterData = lazy(() => import('./Subscriber/Finished/EnterData/EnterData'));
const InternalStat =  lazy(() => import('./Internal/Form/Form'));
const AuthMaster =  lazy(() => import('./Subscriber/Auth/AuthMaster'));

/* bidder */
const BidderList = lazy(() => import('./Bidder2/List/List'));
const BidderSingle = lazy(() => import('./Bidder2/Single/Single'));
const ActiveList =  lazy(() => import('./Bidder2/ActiveList/ActiveList'));
const CancelList =  lazy(() => import('./Bidder2/CancelList/CancelList'));
const InvitedList =  lazy(() => import('./Bidder2/InvitedList/InvitedList'));
const Apply = lazy(() => import('./Bidder2/Apply/Apply'));
const ApplyFix = lazy(() => import('./Bidder2/Apply/Fix/Fix'));
const Search = lazy(() => import('./Bidder2/Search/Search'));
const CalendarSaleWrap = lazy(() => import('./Bidder2/Calendar/CalendarSaleWrap'));
const CalendarViewWrap = lazy(() => import('./Bidder2/Calendar/CalendarViewWrap'));
const BidderProfile = lazy(() => import('./Bidder2/Profile/Profile'));
const SignedList = lazy(() => import('./Bidder2/List/Signed/List'));
const SingleSigned = lazy(() => import('./Bidder2/List/Signed/Single/Single'));
const FavouritesList = lazy(() => import('./Bidder2/Profile/FavouritesList/FavouritesList'));
const Newsletter = lazy(() => import('./Bidder2/Profile/Newsletter'));
const NewsletterConfirm = lazy(() => import('./Bidder2/Profile/NewsletterConfirm'));
const CookiesContent = lazy(()=> import('./hoc/CookieConstent/CookieContent'));

/* admin */
const AdminProfile = lazy(()=> import('./Admin/AdminProfile'));
const GroupSingle = lazy(()=> import('./Admin/Groups/Single/Single'));
const UserSingle = lazy(()=> import('./Admin/Users/Single/Single'));

/* public */
const Home = lazy(()=> import('./Home/Home'));
const Register = lazy(()=> import('./hoc/Register/Register'));
const Login = lazy(()=> import('./hoc/Login/Login'));
const LoginForm = lazy(()=> import('./hoc/Login/LoginForm'));
const ResetPassword = lazy(()=> import('./hoc/Login/ResetPassword'));
const Licence = lazy(()=> import('./hoc/Licence/Licence'));
const ServiceProvider = lazy(()=> import('./hoc/ServiceProvider/ServiceProvider'));
const ServiceProviderConfirm = lazy(()=> import('./hoc/ServiceProvider/ServiceProviderConfirm'));

/* other */
const Content = lazy(() => import('./hoc/Content/Content'));
const IE = lazy(() => import('./hoc/IE/IE'));
const PublicStats = lazy(()=> import('./hoc/Stats/PublicStats'));
const Confirm = lazy(() => import('./hoc/Confirm/Confirm'));
const SelfDiag = lazy(() => new Promise((resolve, reject) => {
    import('./hoc/SelfDiag/SelfDiag')
      .then(result => resolve(result.default ? result : { default: result }))
      .catch(reject);
}));

window.ws = null;

class App extends Component {
    state = {
        jwt_token: null,
        bidderList: null,
        bidderListRefresh: false,
        listParams: null,
        isPopoverOpen: false,
        isPopoverOpenNotification: false
    }

    gaIsInitialized = false;
    singlesignedID = null;
    singleID = null;

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    reloadBidderList = (list) => {
        this.setState({bidderList: list, bidderListRefresh: !this.state.bidderListRefresh});
    }

    reloadPagination = (params) => {
        let tmpPrms = {...this.state.listParams};
        tmpPrms.pagination = params.pagination;

        this.setState({listParams: tmpPrms});
    }

    reloadSort = (sort) => {
        let tmpPrms = {...this.state.listParams};
        tmpPrms.sort = sort.sort;
        this.setState({listParams: tmpPrms});
    }

    sign = async (action, type, jwt = null) => {
        const { cookies } = this.props;
        if (action === "logout") {
            const tmp = this.props.options.parsedToken;
            let title = '';
            let html = '';
            let confirmButtonText = '';
            let showCancelButton = false;
            let deleteToken = false;

            if (type === "reasign") {
                title = i18n.t('sign.swal.title');
                html = i18n.t('sign.swal.content');
                confirmButtonText = i18n.t('sign.swal.btn');
                deleteToken = true;
            } else if (type === "extend") {
                title = i18n.t('sign.extend.title');
                html = i18n.t('sign.extend.content');
                confirmButtonText = i18n.t('sign.extend.btn');
            } else if (type === "logout") {
                title = i18n.t('sign.logout.title');
                html = i18n.t('sign.logout.content');
                confirmButtonText = i18n.t('sign.logout.btn');
                showCancelButton = true;
            }

            await Swal.fire({
                title,
                html,
                icon: "question",
                confirmButtonColor: '#000',
                confirmButtonText,
                showCancelButton,
                cancelButtonText: i18n.t('cancelSingle'),
            }).then((result) => {
                    if (result.isConfirmed) {
                        deleteToken = true;
                        if (type !== "logout") {
                            if ((tmp.isSubscriber !== undefined) && (tmp.isSubscriber)) {
                                window.location.href = env.externallinks.sipass;
                            } else if ((tmp.isBidder !== undefined) && (tmp.isBidder)) {
                                if (tmp.isSipass) {
                                    window.location.href = env.externallinks.sipass;
                                } else {
                                    window.location.href = '/login';
                                }
                            }
                        }
                    }

                    if (deleteToken) {
                        localStorage.removeItem('E-DRAZBE.filterDisplay');
                        this.props.setJwtToken('');
                        cookies.remove('token', { path: '/' });
                        this.setState({jwt_token: '', bidderListRefresh: !this.state.bidderListRefresh});

                        // Set organization parameters from BE to null
                        this.props.setOrgParamsBE(null);
                        localStorage.setItem('E-DRAZBE.licenceData', JSON.stringify(null));

                        if (type === "logout") {
                            this.props.history.push({ pathname: '/' })
                        }
                    }
            });
        } else if (action === "login") {
            const currentLanguage = localStorage.getItem('E-DRAZBE.selectedLanguage');
            const headers = {
                "Accept": 'application/json',
                "Accept-Language": currentLanguage
            }

            console.log("type:",type);
            if (type === "normal") {
                const token = jwt.slice(7, jwt.length) // slice to remove "Bearer "
                const parsedToken = parseJwt(jwt)

                // Redirect subscriber to edrazbe.si (main page)
                if ((parsedToken.isSubscriber) && (['edrazbe'].indexOf(this.props.organization.organization) === -1) && (env.frontend[this.props.organization.organization]['o'] !== parsedToken.organization)) {
                    window.open(env.spa + '/?key=' + token);
                } else {
                    this.props.setJwtToken(jwt);
                    cookies.set('token', token, { path: '/' });
                    this.setState({jwt_token: jwt});

                    // Set organization parameters from BE
                    if (this.props.options.parsedToken.isSubscriber) {
                        axios.get(env.api.private + 'publication/licence-data', this.props.options.postHeaders).then(response => {
                            this.props.setOrgParamsBE(response.data);
                            localStorage.setItem('E-DRAZBE.licenceData', JSON.stringify(response.data));
                        });
                    }
                }
            } else if (type === "sipass") {
                console.log("env:",env);
                console.log("organization:",this.props.organization.organization);

                if (this.props.organization.organization === 'furs') {
                    window.location.href = env.externallinks.sipassFurs;
                }  else if (this.props.organization.organization === 'mju') {
                    window.location.href = env.externallinks.sipassMju;
                } else { // All other organizations
                    window.location.href = env.externallinks.sipass + window.location.host;
                }
            } else if (type === "dev") {
                await axios.post(env.api.public + 'tokens', {}, {headers: headers}).then(response => {
                    if (response.status === 200) {
                        if (this.state.jwt_token.length === 0) {
                            // Filter login options by organization name (do not filter bidders)
                            let inputOptions = response.data.inputOptions;
                            let inputTokens = response.data.tokens;
                            if(this.props.organization.organization !== 'localhost' && this.props.organization.organization !== 'edrazbe') {
                                let filtered = {};
                                let keys = Object.keys(inputTokens);

                                for (let i = 1; i <= keys.length; i++) {
                                    const parsedToken = parseJwt(inputTokens[i]);
                                    if ((env.frontend[this.props.organization.organization]['o'] === parsedToken.organization) || parsedToken.organization === null) {
                                            filtered[i] = inputOptions[i];
                                    }
                                }
                                inputOptions = filtered;
                            }

                            Swal.fire({
                                title: 'Kdo sem jaz?',
                                icon: "question",
                                input: 'select',
                                inputOptions: inputOptions,
                                showCancelButton: false,
                                confirmButtonColor: '#1068ce',
                            }).then((result) => {
                                if (result.value) {
                                    this.props.setJwtToken('Bearer '+response.data.tokens[result.value]);
                                    cookies.set('token', response.data.tokens[result.value], { path: '/' });
                                    this.setState({jwt_token: 'Bearer '+response.data.tokens[result.value]});

                                    // Set organization parameters from BE
                                    if (this.props.options.parsedToken.isSubscriber) {
                                        axios.get(env.api.private + 'publication/licence-data', this.props.options.postHeaders).then(response => {
                                            this.props.setOrgParamsBE(response.data);
                                            localStorage.setItem('E-DRAZBE.licenceData', JSON.stringify(response.data));
                                        });
                                    } else {
                                        setOrgParamsPublic(this.props.organization.organization, this.props.options.postHeaders);
                                    }
                                }
                            });
                        }
                    }
                });
            }
        }
    }

    componentDidUpdate() {
        if (this.props.cookiesConsent.indexOf('ga') !== -1) {
            if (!this.props.initializedGA) {
                let gaId = '';
                if (env.frontend[this.props.organization.organization] !== undefined &&
                    env.frontend[this.props.organization.organization]['ga'] !== undefined &&
                    env.frontend[this.props.organization.organization]['ga'] !== null &&
                    env.frontend[this.props.organization.organization]['ga'] !== ''
                ) {
                    gaId = env.frontend[this.props.organization.organization]['ga'];
                } else {
                    gaId = env.googleAnalytics;
                }

                ReactGA.initialize([{trackingId: gaId}]);
                this.props.initializeGA();
            }
        }
    }

    componentDidMount() {
        const { cookies } = this.props;

        // Get hostname and set organization name
        const hostname = window.location.hostname;
        let organization = '';
        const ukclj_links = ['enakupi.izstop.si', 'enakupi.localhost', 'enakupi.test.edrazbe.si', 'enakupi.kclj.si'];
        if (ukclj_links.includes(hostname)) {
            organization = ['ukcl'];
        } else {
            organization = hostname.split('.');
        }
        this.props.setOrganization({
            hostname: hostname,
            organization: organization[0],
        });

        // Set organization parameters for public and bidder
        if (organization[0] !== 'edrazbe' && (JSON.parse(localStorage.getItem('E-DRAZBE.licenceData-Public')) === undefined || JSON.parse(localStorage.getItem('E-DRAZBE.licenceData-Public')) === null)) {
            setOrgParamsPublic(organization[0], this.props.options.postHeaders);
        }

        // Set language
        setLanguage();
        const currentLanguage = localStorage.getItem('E-DRAZBE.selectedLanguage');
        cookies.set('lang', currentLanguage.split('-')[0], { path: '/' });

        const headers = {
            "Accept": 'application/json',
            "Accept-Language": currentLanguage
        }
        axios.post(env.api.api + '/time', {}, {headers: headers}).then(res => { if (res.status === 200) { this.props.setInitialTime(res.data.unix); } });

        this.props.setAcceptLanguage(localStorage.getItem('E-DRAZBE.selectedLanguage'));
        axios.get(env.api.public + 'property?t=gv&locale='+localStorage.getItem('E-DRAZBE.selectedLanguage')).then(res => {
            if (res.status === 200) {
                this.props.setDictionary(res.data);
            }
        })

        let key = findGetParameter("key");
        if (key) {
            this.props.setJwtToken('Bearer '+key);
            cookies.set('token', key, { path: '/' });
            this.setState({jwt_token: 'Bearer '+key});
            this.singlesignedID = findGetParameter("singlesigned");
            this.singleID = findGetParameter("single");

            // Set organization parameters from BE
            if (this.props.options.parsedToken.isSubscriber) {
                axios.get(env.api.private + 'publication/licence-data', this.props.options.postHeaders).then(response => {
                    this.props.setOrgParamsBE(response.data);
                    localStorage.setItem('E-DRAZBE.licenceData', JSON.stringify(response.data));
                });
            }
        } else {
            const cookie = cookies.get('token');
            if (cookie !== undefined) {
                this.props.setJwtToken('Bearer ' + cookie)
                this.setState({jwt_token: 'Bearer ' + cookie});
            } else {
                this.props.setJwtToken('');
                this.setState({jwt_token: ''});
            }
        }

        // Set organization parameters from BE
        const licenceData = JSON.parse(localStorage.getItem('E-DRAZBE.licenceData'));
        this.props.setOrgParamsBE(licenceData);

        this.initializeWS();
    }

    wsInterval = null;
    wsCheckConnectionInterval = null;
    lastRecievedWsMsg = 0;

    reconnectWebsocket = () => {
        if (window.ws === null) {
            try {
                window.ws = new WebSocket(env.api.wss);
            } catch (exception_var) {
            } finally {
                if (window.ws !== null) {
                    window.ws.onmessage = (evt) => {
                        const message = JSON.parse(evt.data);
                        this.lastRecievedWsMsg = new Date().getTime();
                        this.props.setWsMsg(message);
                    }

                    window.ws.onclose = (evt) => {
                        window.ws = null;
                        this.props.setWsActivity(false);
                    }

                    window.ws.onoffline = (evt) => {}

                    window.ws.onopen = (evt) => {
                        this.props.setWsActivity(true);
                    }
                    window.ws.onerror = (evt) => {
                        window.ws = null;
                        this.props.setWsActivity(false);
                    }

                    window.ws.onpagehide = (evt) => {}

                    window.ws.onpageshow = (evt) => {}

                    window.ws.onunload = (evt) => {}

                    window.addEventListener("beforeunload", function () {
                        if (window.ws !== null) {
                            window.ws.close();
                        }
                    });
                }
            }
        }
    }

    checkWebsocket = () => {
        if (window.ws !== null) {
            if (window.ws.readyState === 1) {
                var current = new Date().getTime();
                var result = current - this.lastRecievedWsMsg;
                if (result > 10000) {
                    window.ws.close();
                }
            }
        }
    }

    initializeWS = () => {
        this.reconnectWebsocket();
        this.wsInterval = setInterval(this.reconnectWebsocket, 35000);
        this.wsCheckConnectionInterval = setInterval(this.checkWebsocket, 5000);
    }

    setIsPopoverOpen = (value, text) => {
        if(text === 'posts') {
            this.setState({isPopoverOpen: value});
        } else {
            this.setState({isPopoverOpenNotification: value});
        }
    }

    render() {
        // Override CSS
        if(this.props.organization !== null && this.props.organization.organization !== 'localhost' && this.props.organization.organization !== '10' && this.props.organization.organization !== 'edrazbe') {
            document.body.classList.add(this.props.organization.organization)
            require(`../src/assets/css/override/override.css`)
        }

        // For Internet Explorer
        if(isIE) {
            return (<IE />);
        }

        if (this.state.jwt_token === null) {
            return (<Loading />);
        }

        if (this.props.options.parsedToken !== undefined) {
            const orgParamsBE = this.props.orgParamsBE;

            if (this.singlesignedID !== null) {
                window.location.href = '/bidder/singlesigned/' + this.singlesignedID;
            } else if (this.singleID !== null) {
                window.location.href = '/bidder/published/single/' + this.singleID;
            }

            return (
                <Fragment>
                    <CookieConsent />
                    <div className="container">
                        <div id="layout-wrapper" >
                            <Header sign={this.sign} cookies={this.props.cookies}/>
                            <Leftside reloadBidderList={this.reloadBidderList} listParams={this.state.listParams} sign={this.sign} />
                            <div id="main-content" className="main-content main-content-private">
                                <div className="page-content">
                                    <Switch>
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/home" exact render={(props) => <Suspense fallback={<Loading />}><Home {...props} />  </Suspense>} />: null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder" exact render={() => <span>Namizje</span>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/search" exact render={(props) => <Suspense fallback={<Loading />}><Search reloadBidderList={this.reloadBidderList} {...props} bidderList={this.state.bidderList} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/calendar/sale" exact render={(props) => <Suspense fallback={<Loading />}><CalendarSaleWrap {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/calendar/view" exact render={(props) => <Suspense fallback={<Loading />}><CalendarViewWrap {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/profile" exact render={(props) => <Suspense fallback={<Loading />}><BidderProfile {...props} sign={this.sign} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/newsletter" exact render={(props) => <Suspense fallback={<Loading />}><Newsletter {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/published/list" exact render={(props) => <Suspense fallback={<Loading />}><BidderList {...props}  bidderList={this.state.bidderList} reloadPagination={this.reloadPagination} reloadSort={this.reloadSort} bidderListRefresh={this.state.bidderListRefresh} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/published/single/:id/:subjectId?" exact render={(props) => <Suspense fallback={<Loading />}><BidderSingle {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/published/apply/:id" exact render={(props) => <Suspense fallback={<Loading />}><Apply {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/published/apply/:id/fix/:submitId/:showbail/:salemethod" exact render={(props) => <Suspense fallback={<Loading />}><ApplyFix {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/signed" exact render={(props) => <Suspense fallback={<Loading />}><SignedList {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/signedended" exact render={(props) => <Suspense fallback={<Loading />}><SignedList options={this.props.options} {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/singlesigned/:id" exact render={(props) => <Suspense fallback={<Loading />}><SingleSigned {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/invited" exact render={(props) => <Suspense fallback={<Loading />}><InvitedList {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/activelist" exact render={(props) => <Suspense fallback={<Loading />}><ActiveList {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/activemylist" exact render={(props) => <Suspense fallback={<Loading />}><ActiveList {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/cancellist" exact render={(props) => <Suspense fallback={<Loading />}><CancelList {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/favouriteslist" exact render={(props) => <Suspense fallback={<Loading />}><FavouritesList {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Route path="/bidder/service-provider/:viewToken?" exact render={(props) => <Suspense fallback={<Loading />}><ServiceProvider/></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Redirect from="/single/:id/title/:title/:subjectId?" to="/bidder/published/single/:id/" /> : null }
                                        {(this.props.options.parsedToken.isBidder) ? <Redirect from="/single/:id/:subjectId?" to="/bidder/published/single/:id/:subjectId?" /> : null }

                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/loading" exact render={() => <Loading />} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber" exact render={() => <SubscriberDashboard />} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/dynamic-stats" exact render={() => <Suspense fallback={<Loading />}><InternalStat type={'private'} hash={Date.now()} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/static-stats" exact render={() => <Suspense fallback={<Loading />}><PublicStats hash={Date.now()} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/drafts/my-list" exact render={() => <Suspense fallback={<Loading />}><DraftList hash={Date.now()} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/drafts/all-list" exact render={() => <Suspense fallback={<Loading />}><DraftList hash={Date.now()} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/drafts/create2/:id?" component={() => <Create2 hash={Date.now()} />} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/drafts/preview/:id" exact render={(props) => <Suspense fallback={<Loading />}><BidderSingle {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/my-list" exact render={() => <Suspense fallback={<Loading />}><PublishedList options={this.props.options} hash={Date.now()} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/all-list" exact render={() => <Suspense fallback={<Loading />}><PublishedList options={this.props.options} hash={Date.now()} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/update/:id" exact render={(props) => <Suspense fallback={<Loading />}><PublishedUpdate2 {...props} /></Suspense>}/> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/single/bidder/:id" exact render={(props) => <Suspense fallback={<Loading />}><PublishedSingleBidder {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/single/:id" exact render={(props) => <Suspense fallback={<Loading />}><PublishedSingle {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/single/:id/print-all" exact render={(props) => <Suspense fallback={<Loading />}><PublishedSinglePrintAll {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/single/:id/decision" exact render={(props) => <Suspense fallback={<Loading />}><PublishedSingleDecision {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/finished/my-list/" exact render={(props) => <Suspense fallback={<Loading />}><FinishedList hash={Date.now()} {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/finished/all-list/" exact render={(props) => <Suspense fallback={<Loading />}><FinishedList hash={Date.now()} {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/finished/enterData/:id?" exact render={(props) => <Suspense fallback={<Loading />}><FinishedEnterData {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/cancel/:id/:status" exact render={(props) => <Suspense fallback={<Loading />}><PublishedCancel {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/archive/my-list/" exact render={(props) => <Suspense fallback={<Loading />}><ArchiveList hash={Date.now()} {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/archive/all-list/" exact render={(props) => <Suspense fallback={<Loading />}><ArchiveList hash={Date.now()} {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/invited/my-list/" exact render={(props) => <Suspense fallback={<Loading />}><SubscriberInvitedList hash={Date.now()} {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/invited/all-list/" exact render={(props) => <Suspense fallback={<Loading />}><SubscriberInvitedList hash={Date.now()} {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/bidders/my-list" exact render={(props) => <Suspense fallback={<Loading />}><PublishedBiddersList options={this.props.options} {...props} hash={Date.now()} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/bidders/all-list" exact render={(props) => <Suspense fallback={<Loading />}><PublishedBiddersList options={this.props.options} {...props} hash={Date.now()} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/published/bidders/single/:id" exact render={(props) => <Suspense fallback={<Loading />}><PublishedBidders options={this.props.options} {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) && (orgParamsBE) && (orgParamsBE.subscriberShowProfile) ? <Route path="/subscriber/profile" exact render={(props) => <Suspense fallback={<Loading />}><SubscriberProfile {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isSubscriber) ? <Route path="/subscriber/auth" exact render={(props) => <Suspense fallback={<Loading />}><AuthMaster {...props} /></Suspense>} /> : null }

                                        {(this.props.options.parsedToken.isAdmin) ? <Route path="/admin/profile" exact render={(props) => <Suspense fallback={<Loading />}><AdminProfile {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isAdmin) ? <Route path="/admin/group/single/:id?" exact render={(props) => <Suspense fallback={<Loading />}><GroupSingle {...props} /></Suspense>} /> : null }
                                        {(this.props.options.parsedToken.isAdmin) ? <Route path="/admin/users/single/:id?" exact render={(props) => <Suspense fallback={<Loading />}><UserSingle {...props} /></Suspense>} /> : null }

                                        <Route path="/selfdiag" exact render={(props) => <Suspense fallback={<Loading />}><SelfDiag /></Suspense>} />
                                        <Route path="/cookies" exact render={(props) => <Suspense fallback={<Loading />}><CookiesContent /></Suspense>} />
                                        <Route path="/help" exact render={(props) => <Suspense fallback={<Loading />}><Content type={this.props.options.parsedToken.isSubscriber ? "signed" : null}/></Suspense>} />
                                        <Route path="/gdpr" exact render={(props) => <Suspense fallback={<Loading />}><Confirm {...props} /></Suspense>} />

                                        {(this.props.options.parsedToken.isSubscriber) ?
                                            <Redirect to='/subscriber'/>
                                            :
                                            (this.props.options.parsedToken.isBidder) ?
                                                <Redirect to='/bidder/published/list'/>
                                                :
                                                <Redirect to='/admin/profile'/>
                                        }
                                    </Switch>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <CookieConsent />

                    {
                        // eslint-disable-next-line
                        env.system_notification_title !== '${X_system_notification_title}' ?
                        <Popover
                            isOpen={this.state.isPopoverOpenNotification}
                            positions={['right']} // preferred positions by priority
                            containerStyle={{"zIndex": "107"}}
                            content={
                                <div style={{padding: "10px 20px", background: "var(--footerBgColor)", color: "var(--footerTextColor)", marginLeft: "5px", width: "200px"}}>
                                    {env.system_notification_text}
                                    <br/>
                                    <button className="btn btn-primary btn-sm mt-2 popover-close-btn" onClick={() => this.setIsPopoverOpen(!this.state.isPopoverOpenNotification, 'notification')}>{i18n.t('close')}</button>
                                </div>
                            }
                        >
                            <div style={{position: "fixed", left: "0px", top: "150px", zIndex: "108", transform: "rotate(90deg)", transformOrigin: "left bottom", background: "var(--footerBgColor)", padding: "10px 20px", color: "var(--footerTextColor)", borderTopRightRadius: "10px", borderTopLeftRadius: "10px", cursor: "pointer"}} onClick={() => this.setIsPopoverOpen(!this.state.isPopoverOpenNotification, 'notification')}>
                                {env.system_notification_title}
                            </div>
                        </Popover>
                        :
                        ""
                    }

                    <div className="container">
                        <div id="layout-wrapper">
                            <Header sign={this.sign} reloadBidderList={this.reloadBidderList} cookies={this.props.cookies}/>
                            <Leftside reloadBidderList={this.reloadBidderList} listParams={this.state.listParams} />
                            <div className="main-content">
                                <div className="page-content">
                                    <Switch>
                                        <Route path="/" exact render={(props) => <Suspense fallback={<Loading />}>
                                            {(['furs', 'posta', 'mju'].indexOf(this.props.organization.organization) !== -1) ?
                                                <BidderList {...props} bidderList={this.state.bidderList} reloadPagination={this.reloadPagination} reloadSort={this.reloadSort} bidderListRefresh={this.state.bidderListRefresh} />
                                                :
                                                <Home {...props} />
                                            }
                                        </Suspense>} />

                                        <Route path="/home" exact render={(props) => <Suspense fallback={<Loading />}><Home {...props} />  </Suspense>} />
                                        <Route path="/list" exact render={(props) => <Suspense fallback={<Loading />}><BidderList {...props} bidderList={this.state.bidderList} reloadPagination={this.reloadPagination} reloadSort={this.reloadSort} bidderListRefresh={this.state.bidderListRefresh} /></Suspense>} />
                                        <Route path="/search" exact render={(props) => <Suspense fallback={<Loading />}><Search options={this.props.options} {...props} reloadBidderList={this.reloadBidderList} /></Suspense>} />
                                        <Route path="/calendar/sale" exact render={(props) => <Suspense fallback={<Loading />}><CalendarSaleWrap {...props} /></Suspense>} />
                                        <Route path="/calendar/view" exact render={(props) => <Suspense fallback={<Loading />}><CalendarViewWrap {...props} /></Suspense>} />
                                        <Route path="/single/:id/title/:title/:subjectId?" exact render={(props) => <Suspense fallback={<Loading />}><BidderSingle {...props} /></Suspense>} />
                                        <Route path="/single/:id/:subjectId?" exact render={(props) => <Suspense fallback={<Loading />}><BidderSingle {...props} /></Suspense>} />
                                        <Route path="/activelist" exact render={(props) => <Suspense fallback={<Loading />}><ActiveList {...props} /></Suspense>} />
                                        <Route path="/cancellist" exact render={(props) => <Suspense fallback={<Loading />}><CancelList {...props} /></Suspense>} />
                                        <Route path="/help" exact render={() => <Suspense fallback={<Loading />}><Content /></Suspense>} />
                                        <Route path="/cookies" exact render={() => <Suspense fallback={<Loading />}><CookiesContent /></Suspense>} />
                                        <Route path="/stats" exact render={() => <Suspense fallback={<Loading />}><PublicStats/></Suspense>} />
                                        <Route path="/selfdiag" exact render={() => <Suspense fallback={<Loading />}><SelfDiag/></Suspense>} />
                                        <Route path="/newsletter" exact render={() => <Suspense fallback={<Loading />}><Newsletter/></Suspense>} />
                                        <Route path="/newsletter/confirm/:token?/:updateToken?" exact render={(props) => <Suspense fallback={<Loading />}><NewsletterConfirm/></Suspense>} />
                                        <Route path="/newsletter/update/:token?" exact render={() => <Suspense fallback={<Loading />}><Newsletter/></Suspense>} />
                                        <Route path="/newsletter/getToken" exact render={() => <Suspense fallback={<Loading />}><NewsletterConfirm/></Suspense>} />
                                        <Route path="/licence" exact render={() => <Suspense fallback={<Loading />}><Licence/></Suspense>} />
                                        <Route path="/public/service-provider/:viewToken?" exact render={() => <Suspense fallback={<Loading />}><ServiceProvider/></Suspense>} />
                                        <Route path="/public/service-provider/confirm/:token" exact render={() => <Suspense fallback={<Loading />}><ServiceProviderConfirm/></Suspense>} />

                                        <Route path="/login" exact render={(props) => <Suspense fallback={<Loading />}><Login {...props} sign={this.sign}/></Suspense>} />
                                        <Route path="/login/normal" exact render={(props) => <Suspense fallback={<Loading />}><LoginForm {...props} sign={this.sign}/></Suspense>} />
                                        <Route path="/register" exact render={(props) => <Suspense fallback={<Loading />}><Register {...props} sign={this.sign}/></Suspense>} />
                                        <Route path="/resetPassword" exact render={(props) => <Suspense fallback={<Loading />}><ResetPassword {...props} sign={this.sign}/></Suspense>} />
                                        <Route path="/gdpr" exact render={(props) => <Suspense fallback={<Loading />}><Confirm {...props} /></Suspense>} />

                                        <Redirect from="/bidder/published/single/:id/:subjectId?" to="/single/:id/:subjectId?" />
                                        <Redirect from="/bidder/singlesigned/:id" to="/single/:id/:subjectId?" />
                                        <Redirect to='/' />
                                    </Switch>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </Fragment>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        options: state.options,
        cookiesConsent: state.cookiesConsent,
        initializedGA: state.initializedGA,
        organization: state.organization,
        orgParamsBE: state.orgParamsBE,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setAcceptLanguage: (lng) => dispatch({type: 'SETACCEPTLANUAGE', value: lng}),
        setJwtToken: (token) => dispatch({type: 'SETJWTTOKEN', value: token}),
        initializeGA: () => dispatch({type: 'INITIALIZEGA'}),
        setWsMsg: (message) => dispatch({type: 'SETWSMSG', value: message}),
        setWsActivity: (message) => dispatch({type: 'SETWSACTIVITY', value: message}),
        setInitialTime: (message) => dispatch({type: 'SETTIME', value: message}),
        setDictionary: (dictionary) => dispatch({type: 'SETDICTIONARY', value: dictionary}),
        setOrganization: (organization) => dispatch({type: 'SETORGANIZATION', value: organization}),
        setOrgParamsBE: (orgParamsBE) => dispatch({type: 'SETORGANIZATIONPARAMSBE', value: orgParamsBE}),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withCookies(App)));
